import { render, staticRenderFns } from "./InvitationLayout.vue?vue&type=template&id=2de401b7&"
import script from "./InvitationLayout.vue?vue&type=script&setup=true&lang=ts&"
export * from "./InvitationLayout.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports